export default __webpack_public_path__ + "static/media/DNo.30-4.0187a6c0.jpg";